import { isElecwattDev, isElecwattProd } from "@linkpi/elecwatt";
import { isWeb } from "@uni/env";
import * as json1 from "ot-json1";
import ReconnectingWebSocket from "reconnecting-websocket";
import richText from "rich-text";
// FIXME: shareDB 强制依赖 noode events

import shareDb from "sharedb/lib/client";
shareDb.types.register(json1.type);
shareDb.types.register(richText.type);

// 向服务器刷新token的时间 1小时
const REFRESH_TOKEN_SIGN = 1000 * 60 * 60;
const SOCKETSTATUS = {
  OFFLINE: 0,
  ONLINE: 1
};
const reconnectingConfig = {
  maxReconnectionDelay: 1000,
  // 最大最小重试时间
  minReconnectionDelay: 500,
  connectionTimeout: 3000 // 连接超时时间，超时->delay->reconnect
};

// TODO destory 断开有时比较慢 改成假的断开
// 然后按时间或连接数，扫描可以释放的
const destroyContainer = {
  destroyList: [],
  waitList: [],
  handleShare(collection, id, share) {
    const sign = `${collection}_${id}`;
    const oldDestroy = share.destroy.bind(share);
    // 封装一下share的destroy
    share.destroy = oldCb => {
      // 发起断开时 记录id
      this.destroyList.push(sign);
      oldDestroy(() => {
        // 清除标记
        this.destroyList = this.destroyList.filter(x => x !== sign);
        // 通知
        this.waitList.filter(x => x.key === sign).forEach(notice => {
          notice?.handle?.();
        });
        oldCb?.();
      });
    };
  },
  wait(collection, id) {
    const sign = `${collection}_${id}`;
    return new Promise((r, f) => {
      if (this.destroyList.includes(sign)) {
        console.log("wait");
        this.waitList.push({
          key: sign,
          handle: () => {
            r();
          }
        });
      } else {
        r();
      }
    });
  }
};
export class Connection {
  urlList;
  id;
  token;
  unambiguousUrl;
  updateTokenTimeSign;
  _socketStatus;
  hooks;
  urlIndex = 0;
  errorCount = 0;
  totalError = 0;
  errorTime = 0;
  url;
  socket = null;
  db_connection = null;
  ping = null;
  constructor() {
    this.id = null;
    this.token = null;
    this.unambiguousUrl = null;
    this.updateTokenTimeSign = 0;
    this._socketStatus = SOCKETSTATUS.OFFLINE;
    this.hooks = {
      messageerror: null,
      onSocketStatusChange: null
    };
    console.log(window.location.host);
    if (window.location.host.startsWith("lab") && window.location.host.includes(".mylinkpi.com")) {
      this.urlList = ["wss://lab-doc.mylinkpi.com/"];
    } else if (window.location.host.startsWith("127.") || window.location.host.startsWith("192.") || window.location.host.startsWith("localhost")) {
      this.urlList = ["wss://doct3.mylinkpi.com/"];
      // this.urlList = [`ws://${window.location.host}/docapi`];
    } else if (window.location.host.startsWith("test-inner") || window.location.host.split(".")?.[1] === "test") {
      this.urlList = Math.random() > 0.5 ? ["wss://doct3.mylinkpi.com/", "wss://doct4.mylinkpi.com/"] : ["wss://doct4.mylinkpi.com/", "wss://doct3.mylinkpi.com/"];
    } else if (window.location.host.startsWith("www.idealhangzhoucity.com") || window.location.host.startsWith("cfg.idealhangzhoucity.com")) {
      this.urlList = Math.random() > 0.5 ? ["wss://doct1.idealhangzhoucity.com/", "wss://doct2.idealhangzhoucity.com/"] : ["wss://doct2.idealhangzhoucity.com/", "wss://doct1.idealhangzhoucity.com/"];
    } else if (isElecwattProd()) {
      this.urlList = Math.random() > 0.5 ? ["wss://doct1.ljp.elecwatt.com/", "wss://doct2.ljp.elecwatt.com/"] : ["wss://doct2.ljp.elecwatt.com/", "wss://doct1.ljp.elecwatt.com/"];
    } else if (isElecwattDev()) {
      this.urlList = ["wss://test.ljp.elecwatt.com/docapi"];
    } else if (window.location.host.includes("idealhangzhoucity.com")) {
      this.urlList = ["wss://test.idealhangzhoucity.com/docapi"];
    } else {
      this.urlList = Math.random() > 0.5 ? ["wss://doct1.mylinkpi.com/", "wss://doct2.mylinkpi.com/"] : ["wss://doct2.mylinkpi.com/", "wss://doct1.mylinkpi.com/"];
    }
    this.urlIndex = 0;
    this.errorCount = 0;
    this.totalError = 0;
    this.errorTime = 0;
    this.url = this.getUrl.bind(this);
    this.init = this.init.bind(this);
    this.init();
  }
  get socketStatus() {
    return this._socketStatus;
  }
  set socketStatus(val) {
    this._socketStatus = val;
    this.hooks.onSocketStatusChange && this.hooks.onSocketStatusChange(val);
  }
  getUrl() {
    if (this.errorCount > 3) {
      this.errorCount = 0;
      if (this.urlIndex === this.urlList.length - 1) {
        this.urlIndex = 0;
      } else {
        this.urlIndex++;
      }
    }
    this.errorCount++;
    if (this.totalError > 10) {
      window.location.reload();
    } else {
      if (this.totalError === 0) {
        this.errorTime = Date.now();
      } else if (Date.now() - this.errorTime > 3600_000) {
        this.errorTime = Date.now();
        this.totalError = 0;
      }
      this.totalError++;
    }
    return this.urlList[this.urlIndex];
  }
  init() {
    if (this.socket) {
      this.socket.close && this.socket.close();
    }
    this.socket = new ReconnectingWebSocket(this.unambiguousUrl || this.url, [], reconnectingConfig);
    this.db_connection = new shareDb.Connection(this.socket);
    if (process.env.NODE_ENV === "production") {
      // dev
      // @ts-ignore
      window.db_connection = this.db_connection;
      // @ts-ignore
      window.db_socket = this.socket;
    }
    this.socket.addEventListener("open", () => {
      this.socketStatus = SOCKETSTATUS.ONLINE;
      this.checkToken(true);
    });
    this.socket.addEventListener("close", () => {
      this.socketStatus = SOCKETSTATUS.OFFLINE;
    });
    this.socket.addEventListener("error", () => {
      this.socketStatus = SOCKETSTATUS.OFFLINE;
    });
    this.socket.addEventListener("message", m => {
      this.onMessage(m);
    });

    /**
     * 网络状态变化，主动断开和重连
     */
    window.addEventListener("offline", event => {
      console.log("offline");
      this.socket?.close();
    });
    window.addEventListener("online", () => {
      console.log("online");
      this.socket?.reconnect();
    });
    this.ping = this.db_connection.get("testE1", "ping");
    this.ping.subscribe();
  }
  setUnambiguousUrl(newUrl) {
    this.unambiguousUrl = newUrl;
    this.init();
  }
  setToken({
    id,
    token
  }) {
    this.id = id;
    this.token = token;
    return this;
  }
  onMessage(m) {
    const data = JSON.parse(m.data);
    if ("error" in data && "message" in data.error) {
      let msg;
      if (data.error.message.startsWith("403")) {
        msg = "服务端拒绝";
      } else {
        msg = data.error.message;
      }
      this.hooks.messageerror && this.hooks.messageerror(msg);
    }
  }

  // 注册message error
  onMessageError(fn) {
    this.hooks.messageerror = fn;
  }
  onSocketStatusChange(fn) {
    this.hooks.onSocketStatusChange = fn;
    fn(this.socketStatus);
  }
  checkToken(force) {
    const t = Date.now();
    if (force || t - this.updateTokenTimeSign > REFRESH_TOKEN_SIGN) {
      const id = window.localStorage.getItem("ad");
      const token = window.localStorage.getItem("token");
      if (this.sendToken({
        id,
        token
      })) this.updateTokenTimeSign = t;
    }
  }

  // 建立sharedb channel
  get(collection, id) {
    this.checkToken(true);
    const share = this.db_connection?.get(collection, id);

    // 将对数据操作前触发（tree and document）
    share?.on("before op", () => this.checkToken());
    return share;
  }

  // 如果这个连接正在断开，那么直接 get 可能会永远不会被触发
  // 所以 如果在断开前再次连接这个collectionId 那么需要等待断开操作结束后，才发起连接
  getSafe(collection, id) {
    const sign = `${collection}_${id}`;
    return new Promise(async (r, f) => {
      await destroyContainer.wait(collection, id);
      const share = this.get(collection, id);
      destroyContainer.handleShare(collection, id, share);
      r(share);
    });
  }
  sendToken({
    id,
    token
  }) {
    if (token !== null && id !== null) {
      this.socket?.send(JSON.stringify({
        LJP_TOKEN: token,
        LJP_ID: id
      }));
      return true;
    }
    return false;
  }
  getDBConnection() {
    return this.db_connection;
  }
}
let instance = null;
export const initConnection = () => {
  console.info("初始化 connection");
  if (instance) return;
  if (isWeb) {
    instance = new Connection();
  }
};

// 小程序环境不需要这个连接
export const getShareDBConnectionInstance = () => instance;